/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuPublishResponse } from '../../models/menu-publish-response';

export interface MenusMenuIdPublishConfigsGet$Params {
  menuId: string;
  'Active-Tenant-Identifier': string;
}

export function menusMenuIdPublishConfigsGet(http: HttpClient, rootUrl: string, params: MenusMenuIdPublishConfigsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuPublishResponse>> {
  const rb = new RequestBuilder(rootUrl, menusMenuIdPublishConfigsGet.PATH, 'get');
  if (params) {
    rb.path('menuId', params.menuId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuPublishResponse>;
    })
  );
}

menusMenuIdPublishConfigsGet.PATH = '/menus/{menuId}/publish-configs';
